import type { FieldReportListItem } from '@/modules/field/types';
import { sortFieldReportsChronologically } from '@/modules/field/utils/fieldReportListSort';

/** Máximo de RDOs sincronizados mantidos no dispositivo (pendentes sempre ficam). */
export const FIELD_REPORTS_CACHE_CAP = 450;

export function capFieldReportsList(
  reports: FieldReportListItem[],
): FieldReportListItem[] {
  const pending = reports.filter((report) => report.sync === 'not_synced');
  const synced = reports.filter((report) => report.sync !== 'not_synced');

  if (synced.length <= FIELD_REPORTS_CACHE_CAP) {
    return reports;
  }

  const sortedSynced = sortFieldReportsChronologically(synced);
  const keepSynced = sortedSynced.slice(0, FIELD_REPORTS_CACHE_CAP);
  const keepIds = new Set(keepSynced.map((report) => report.id));

  const prunedSynced = synced.filter((report) => keepIds.has(report.id));

  return sortFieldReportsChronologically([...pending, ...prunedSynced]);
}
